import React from 'react'
import { Link } from 'react-router-dom'

function Gallery() {
  return (
    <div>
        <div>
  <div className="loader" />
  <div id="app">
          <div className="main-wrapper main-wrapper-1">
            <div className="navbar-bg" />
            <nav className="navbar navbar-expand-lg main-navbar sticky">
              <div className="form-inline mr-auto">
                <ul className="navbar-nav mr-3">
                  <li>
                    <a
                      href="#"
                      data-toggle="sidebar"
                      className="nav-link nav-link-lg
									collapse-btn"
                    >
                      {" "}
                      <i data-feather="align-justify" />
                    </a>
                  </li>
                  <li>
                    <a href="#" className="nav-link nav-link-lg fullscreen-btn">
                      <i data-feather="maximize" />
                    </a>
                  </li>
                  <li>
                    <form className="form-inline mr-auto">
                      <div className="search-element">
                        <input
                          className="form-control"
                          type="search"
                          placeholder="Search"
                          aria-label="Search"
                          data-width={200}
                        />
                        <button className="btn" type="submit">
                          <i className="fas fa-search" />
                        </button>
                      </div>
                    </form>
                  </li>
                </ul>
              </div>
              <ul className="navbar-nav navbar-right">
                <li className="dropdown dropdown-list-toggle">
                  <a
                    href="#"
                    data-toggle="dropdown"
                    className="nav-link nav-link-lg message-toggle"
                  >
                    <i data-feather="mail" />
                    <span className="badge headerBadge1">6 </span>{" "}
                  </a>
                  <div className="dropdown-menu dropdown-list dropdown-menu-right pullDown">
                    <div className="dropdown-header">
                      Messages
                      <div className="float-right">
                        <a href="#">Mark All As Read</a>
                      </div>
                    </div>
                    <div className="dropdown-list-content dropdown-list-message">
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span
                          className="dropdown-item-avatar
											text-white"
                        >
                          {" "}
                          <img
                            alt="image"
                            src="assets/img/users/user-1.png"
                            className="rounded-circle"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <span className="message-user">Hero Gaur</span>
                          <span className="time messege-text">
                            Please check your mail !!
                          </span>
                          <span className="time">2 Min Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-avatar text-white">
                          <img
                            alt="image"
                            src="assets/img/users/user-2.png"
                            className="rounded-circle"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <span className="message-user">Sarah Smith</span>{" "}
                          <span className="time messege-text">
                            Request for leave application
                          </span>
                          <span className="time">5 Min Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-avatar text-white">
                          <img
                            alt="image"
                            src="assets/img/users/user-5.png"
                            className="rounded-circle"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <span className="message-user">Jacob Ryan</span>{" "}
                          <span className="time messege-text">
                            Your payment invoice is generated.
                          </span>{" "}
                          <span className="time">12 Min Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-avatar text-white">
                          <img
                            alt="image"
                            src="assets/img/users/user-4.png"
                            className="rounded-circle"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <span className="message-user">Lina Smith</span>{" "}
                          <span className="time messege-text">
                            hii Hero, I have upload doc related to task.
                          </span>{" "}
                          <span className="time">30 Min Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-avatar text-white">
                          <img
                            alt="image"
                            src="assets/img/users/user-3.png"
                            className="rounded-circle"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <span className="message-user">Jalpa Joshi</span>{" "}
                          <span className="time messege-text">
                            Please do as specify. Let me know if you have any
                            query.
                          </span>{" "}
                          <span className="time">1 Days Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-avatar text-white">
                          <img
                            alt="image"
                            src="assets/img/users/user-2.png"
                            className="rounded-circle"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <span className="message-user">Sarah Smith</span>{" "}
                          <span className="time messege-text">
                            Client Requirements
                          </span>
                          <span className="time">2 Days Ago</span>
                        </span>
                      </a>
                    </div>
                    <div className="dropdown-footer text-center">
                      <a href="#">
                        View All <i className="fas fa-chevron-right" />
                      </a>
                    </div>
                  </div>
                </li>
                <li className="dropdown dropdown-list-toggle">
                  <a
                    href="#"
                    data-toggle="dropdown"
                    className="nav-link notification-toggle nav-link-lg"
                  >
                    <i data-feather="bell" className="bell" />
                  </a>
                  <div className="dropdown-menu dropdown-list dropdown-menu-right pullDown">
                    <div className="dropdown-header">
                      Notifications
                      <div className="float-right">
                        <a href="#">Mark All As Read</a>
                      </div>
                    </div>
                    <div className="dropdown-list-content dropdown-list-icons">
                      <a
                        href="#"
                        className="dropdown-item dropdown-item-unread"
                      >
                        {" "}
                        <span className="dropdown-item-icon bg-primary text-white">
                          {" "}
                          <i
                            className="fas
												fa-code"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          Template update is available now!{" "}
                          <span className="time">2 Min Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-icon bg-info text-white">
                          {" "}
                          <i
                            className="far
												fa-user"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <b>You</b> and <b>Dedik Sugiharto</b> are now friends{" "}
                          <span className="time">10 Hours Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-icon bg-success text-white">
                          {" "}
                          <i
                            className="fas
												fa-check"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          <b>Kusnaedi</b> has moved task <b>Fix bug header</b>{" "}
                          to <b>Done</b>{" "}
                          <span className="time">12 Hours Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-icon bg-danger text-white">
                          {" "}
                          <i className="fas fa-exclamation-triangle" />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          Low disk space. Let's clean it!{" "}
                          <span className="time">17 Hours Ago</span>
                        </span>
                      </a>{" "}
                      <a href="#" className="dropdown-item">
                        {" "}
                        <span className="dropdown-item-icon bg-info text-white">
                          {" "}
                          <i
                            className="fas
												fa-bell"
                          />
                        </span>{" "}
                        <span className="dropdown-item-desc">
                          {" "}
                          Welcome to Otika template!{" "}
                          <span className="time">Yesterday</span>
                        </span>
                      </a>
                    </div>
                    <div className="dropdown-footer text-center">
                      <a href="#">
                        View All <i className="fas fa-chevron-right" />
                      </a>
                    </div>
                  </div>
                </li>
                <li className="dropdown">
                  <a
                    href="#"
                    data-toggle="dropdown"
                    className="nav-link dropdown-toggle nav-link-lg nav-link-user"
                  >
                    {" "}
                    <img
                      alt="image"
                      src="assets/img/user.png"
                      className="user-img-radious-style"
                    />{" "}
                    <span className="d-sm-none d-lg-inline-block" />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right pullDown">
                    <div className="dropdown-title">Hello Sarah Smith</div>
                    <Link to="/profile" className="dropdown-item has-icon">
                      {" "}
                      <i
                        className="far
										fa-user"
                      />{" "}
                      Profile
                    </Link>{" "}
                    <a href="timeline.html" className="dropdown-item has-icon">
                      {" "}
                      <i className="fas fa-bolt" />
                      Activities
                    </a>{" "}
                    <a href="#" className="dropdown-item has-icon">
                      {" "}
                      <i className="fas fa-cog" />
                      Settings
                    </a>
                    <div className="dropdown-divider" />
                    <a
                      href="auth-login.html"
                      className="dropdown-item has-icon text-danger"
                    >
                      {" "}
                      <i className="fas fa-sign-out-alt" />
                      Logout
                    </a>
                  </div>
                </li>
              </ul>
            </nav>
            <div className="main-sidebar sidebar-style-2">
              <aside id="sidebar-wrapper">
                <div className="sidebar-brand">
                  <Link to="/">
                    {" "}
                    <img
                      alt="image"
                      src="assets/img/logo.png"
                      className="header-logo"
                    />{" "}
                    <span className="logo-name">Otika</span>
                  </Link>
                </div>
                <ul className="sidebar-menu">
                  <li className="menu-header">Main</li>
                  <li className="dropdown active">
                    <Link to="/" className="nav-link">
                      <i data-feather="monitor" />
                      <span>Dashboard</span>
                    </Link>
                  </li>

                  <li className="dropdown">
                    <a href="#" className="menu-toggle nav-link has-dropdown">
                      <i data-feather="shopping-bag" />
                      <span>Advanced</span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <a className="nav-link" href="avatar.html">
                          Avatar
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="card.html">
                          Card
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="modal.html">
                          Modal
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="sweet-alert.html">
                          Sweet Alert
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="toastr.html">
                          Toastr
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="empty-state.html">
                          Empty State
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="multiple-upload.html">
                          Multiple Upload
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="pricing.html">
                          Pricing
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="tabs.html">
                          Tab
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li className="menu-header">Media</li>
                  <li className="dropdown">
                    <a href="#" className="menu-toggle nav-link has-dropdown">
                      <i data-feather="image" />
                      <span>Gallery</span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link className="nav-link" to="/lightgallery">
                          Light Gallery
                        </Link>
                      </li>
                      <li>
                        <Link to="/gallery">Gallery 2</Link>
                      </li>
                    </ul>
                  </li>

                  <li className="dropdown">
                    <a href="#" className="menu-toggle nav-link has-dropdown">
                      <i data-feather="anchor" />
                      <span>Other Pages</span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <a className="nav-link" href="create-post.html">
                          Create Post
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="posts.html">
                          Posts
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="profile.html">
                          Profile
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="contact.html">
                          Contact
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="invoice.html">
                          Invoice
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </aside>
            </div>
      {/* Main Content */}
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12 col-sm-12 col-lg-4">
                <div className="row">
                  <div className="col-12 col-sm-6 col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <h4>Gallery</h4>
                      </div>
                      <div className="card-body">
                        <div className="gallery">
                          <div className="gallery-item" data-image="assets/img/blog/img01.png" data-title="Image 1" />
                          <div className="gallery-item" data-image="assets/img/blog/img02.png" data-title="Image 2" />
                          <div className="gallery-item" data-image="assets/img/blog/img03.png" data-title="Image 3" />
                          <div className="gallery-item" data-image="assets/img/blog/img04.png" data-title="Image 4" />
                          <div className="gallery-item" data-image="assets/img/blog/img05.png" data-title="Image 5" />
                          <div className="gallery-item" data-image="assets/img/blog/img06.png" data-title="Image 6" />
                          <div className="gallery-item" data-image="assets/img/blog/img07.png" data-title="Image 7" />
                          <div className="gallery-item" data-image="assets/img/blog/img08.png" data-title="Image 8" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <h4>Gallery</h4>
                      </div>
                      <div className="card-body">
                        <div className="gallery">
                          <div className="gallery-item" data-image="assets/img/blog/img05.png" data-title="Image 1" />
                          <div className="gallery-item" data-image="assets/img/blog/img08.png" data-title="Image 2" />
                          <div className="gallery-item" data-image="assets/img/blog/img04.png" data-title="Image 3" />
                          <div className="gallery-item" data-image="assets/img/blog/img11.png" data-title="Image 4" />
                          <div className="gallery-item" data-image="assets/img/blog/img02.png" data-title="Image 5" />
                          <div className="gallery-item" data-image="assets/img/blog/img05.png" data-title="Image 6" />
                          <div className="gallery-item" data-image="assets/img/blog/img03.png" data-title="Image 7" />
                          <div className="gallery-item gallery-more" data-image="assets/img/blog/img02.png" data-title="Image 8">
                            <div>+2</div>
                          </div>
                          <div className="gallery-item gallery-hide" data-image="assets/img/blog/img11.png" data-title="Image 9" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="card">
                  <div className="card-header">
                    <h4>Gallery <code>.gallery-md</code></h4>
                  </div>
                  <div className="card-body">
                    <div className="gallery gallery-md">
                      <div className="gallery-item" data-image="assets/img/blog/img03.png" data-title="Image 1" />
                      <div className="gallery-item" data-image="assets/img/blog/img14.png" data-title="Image 2" />
                      <div className="gallery-item" data-image="assets/img/blog/img08.png" data-title="Image 3" />
                      <div className="gallery-item" data-image="assets/img/blog/img05.png" data-title="Image 4" />
                      <div className="gallery-item" data-image="assets/img/blog/img11.png" data-title="Image 5" />
                      <div className="gallery-item" data-image="assets/img/blog/img09.png" data-title="Image 6" />
                      <div className="gallery-item" data-image="assets/img/blog/img12.png" data-title="Image 8" />
                      <div className="gallery-item" data-image="assets/img/blog/img13.png" data-title="Image 9" />
                      <div className="gallery-item" data-image="assets/img/blog/img14.png" data-title="Image 10" />
                      <div className="gallery-item" data-image="assets/img/blog/img15.png" data-title="Image 11" />
                      <div className="gallery-item gallery-more" data-image="assets/img/blog/img08.png" data-title="Image 12">
                        <div>+2</div>
                      </div>
                      <div className="gallery-item gallery-hide" data-image="assets/img/blog/img01.png" data-title="Image 9" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="card">
                  <div className="card-header">
                    <h4>Gallery <code>.gallery-fw</code></h4>
                  </div>
                  <div className="card-body">
                    <div className="gallery gallery-fw" data-item-height={100}>
                      <div className="gallery-item" data-image="assets/img/blog/img09.png" data-title="Image 1" />
                      <div className="gallery-item" data-image="assets/img/blog/img10.png" data-title="Image 2" />
                      <div className="gallery-item gallery-more" data-image="assets/img/blog/img08.png" data-title="Image 3">
                        <div>+2</div>
                      </div>
                      <div className="gallery-item gallery-hide" data-image="assets/img/blog/img01.png" data-title="Image 4" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="settingSidebar">
          <a href="javascript:void(0)" className="settingPanelToggle"> <i className="fa fa-spin fa-cog" />
          </a>
          <div className="settingSidebar-body ps-container ps-theme-default">
            <div className=" fade show active">
              <div className="setting-panel-header">Setting Panel
              </div>
              <div className="p-15 border-bottom">
                <h6 className="font-medium m-b-10">Select Layout</h6>
                <div className="selectgroup layout-color w-50">
                  <label className="selectgroup-item">
                    <input type="radio" name="value" defaultValue={1} className="selectgroup-input-radio select-layout" defaultChecked />
                    <span className="selectgroup-button">Light</span>
                  </label>
                  <label className="selectgroup-item">
                    <input type="radio" name="value" defaultValue={2} className="selectgroup-input-radio select-layout" />
                    <span className="selectgroup-button">Dark</span>
                  </label>
                </div>
              </div>
              <div className="p-15 border-bottom">
                <h6 className="font-medium m-b-10">Sidebar Color</h6>
                <div className="selectgroup selectgroup-pills sidebar-color">
                  <label className="selectgroup-item">
                    <input type="radio" name="icon-input" defaultValue={1} className="selectgroup-input select-sidebar" />
                    <span className="selectgroup-button selectgroup-button-icon" data-toggle="tooltip" data-original-title="Light Sidebar"><i className="fas fa-sun" /></span>
                  </label>
                  <label className="selectgroup-item">
                    <input type="radio" name="icon-input" defaultValue={2} className="selectgroup-input select-sidebar" defaultChecked />
                    <span className="selectgroup-button selectgroup-button-icon" data-toggle="tooltip" data-original-title="Dark Sidebar"><i className="fas fa-moon" /></span>
                  </label>
                </div>
              </div>
              <div className="p-15 border-bottom">
                <h6 className="font-medium m-b-10">Color Theme</h6>
                <div className="theme-setting-options">
                  <ul className="choose-theme list-unstyled mb-0">
                    <li title="white" className="active">
                      <div className="white" />
                    </li>
                    <li title="cyan">
                      <div className="cyan" />
                    </li>
                    <li title="black">
                      <div className="black" />
                    </li>
                    <li title="purple">
                      <div className="purple" />
                    </li>
                    <li title="orange">
                      <div className="orange" />
                    </li>
                    <li title="green">
                      <div className="green" />
                    </li>
                    <li title="red">
                      <div className="red" />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="p-15 border-bottom">
                <div className="theme-setting-options">
                  <label className="m-b-0">
                    <input type="checkbox" name="custom-switch-checkbox" className="custom-switch-input" id="mini_sidebar_setting" />
                    <span className="custom-switch-indicator" />
                    <span className="control-label p-l-10">Mini Sidebar</span>
                  </label>
                </div>
              </div>
              <div className="p-15 border-bottom">
                <div className="theme-setting-options">
                  <label className="m-b-0">
                    <input type="checkbox" name="custom-switch-checkbox" className="custom-switch-input" id="sticky_header_setting" />
                    <span className="custom-switch-indicator" />
                    <span className="control-label p-l-10">Sticky Header</span>
                  </label>
                </div>
              </div>
              <div className="mt-4 mb-4 p-3 align-center rt-sidebar-last-ele">
                <a href="#" className="btn btn-icon icon-left btn-primary btn-restore-theme">
                  <i className="fas fa-undo" /> Restore Default
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="main-footer">
        <div className="footer-left">
          <a href="templateshub.net">Templateshub</a>
        </div>
        <div className="footer-right">
        </div>
      </footer>
    </div>
  </div>
</div>

    </div>
  )
}

export default Gallery